import {
  Backdrop, Button, Card, CardContent, CardHeader,
  CircularProgress, Container,
  Dialog, DialogActions, DialogContent, DialogTitle,
  Divider, Grid, Input, Select,
  MenuItem, Paper,
  Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination,
  TableRow, Typography
} from '@material-ui/core';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import EditIcon from '@material-ui/icons/Edit';
import ImageRejectIcon from '@material-ui/icons/ThumbDown';
import ImageAcceptIcon from '@material-ui/icons/ThumbUp';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/styles';
import React, { useEffect } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import Page from 'src/components/Page';
import AddressSearch from 'src/components/Selects/AddressSearch';
import axios from "src/utils/axios";
import { CreateWareHouseAddress, getUser } from 'src/utils/Common';
import SendIcon from '@material-ui/icons/Send';
import PrintIcon from '@material-ui/icons/Print';
import BarcodeImage from 'src/components/BarcodeImage';




const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  todos: {
    marginTop: theme.spacing(1)
  }, backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  resize: {
    fontSize: 50
  },
  tableContainer: {
    maxHeight: '100%',
    overflow: 'auto',
  },
}));

const defaultUyari = { open: false, aciklama: '', tip: 'success' };






function PassOut() {
  const classes = useStyles();
  const [Loading, setLoading] = React.useState(false);
  const [dataPaslasma, setPaslasmaData] = React.useState([]);
  const [uyari, setUyari] = React.useState(defaultUyari);
  const [Print, setPrint] = React.useState(false);
  const [Etiket, setEtiket] = React.useState('');
  const [Name, setName] = React.useState('');
  const [Phone, setPhone] = React.useState('');
  const [Address, setAddress] = React.useState('');
  const [KargoOdemeDurum, setKargoOdemeDurum] = React.useState('');
  const [pagination, setPagination] = React.useState({ page: 0, rowsPerPage: 10 });
  const user = getUser();
  const [containerHeight, setContainerHeight] = React.useState('auto');


  const [passEditParam, setPassEditParam] = React.useState('');

  useEffect(() => {
    const handleResize = () => {
      const windowHeight = window.innerHeight;
      const headerHeight = document.querySelector('header').offsetHeight;
      const newHeight = windowHeight - headerHeight - 145; // 50 is a buffer for padding/margin
      setContainerHeight(newHeight);
    };

    handleResize(); // Initial call to set height

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(defaultUyari);
  };

  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  const GetOpenPassByService = () => {
    axios.get("GetOpenPassByService/2/" + user.ServiceShopId)
      .then(response => {
        // console.log(response);
        setPaslasmaData(response.data);
        setLoading(false);
      }).catch(error => {
        setLoading(false);
      });
  }

  useEffect(() => {
    CreateWareHouseAddress(user.ServiceShopId);
    GetOpenPassByService();
  }, []);



  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('');
  const [passEdit, setPassEdit] = React.useState(false);

  const GetPassEditPopUp = (event, ID) => {
    setPassEditParam(ID);
    setPassEdit(true);
  }






  const [KargoNovalue, setKargoNovalue] = React.useState('');
  const [EFaturaNo, setEFaturaNo] = React.useState("");

  const handleKargoNoInputChange = (event) => {
    setKargoNovalue(event.target.value === '' ? '' : event.target.value);
  };

  const [GonderiTipvalue, setGonderiTipvalue] = React.useState(0);

  const handleGonderiTipInputChange = (event) => {
    setGonderiTipvalue(event.target.value === '' ? '' : Number(event.target.value));
  };
  const handleEFaturaNoInputChange = (event) => {
    setEFaturaNo(event.target.value === '' ? '' : event.target.value);
  };


  function SetGonderimBilgisiEvet() {
    if (KargoNovalue === ''
      && (parseInt(GonderiTipvalue) === 1
        || parseInt(GonderiTipvalue) === 3
        || parseInt(GonderiTipvalue) === 4
        || parseInt(GonderiTipvalue) === 5)
    ) {
      setUyari({ open: true, aciklama: 'Kargo Numarası girilmeden kabul edilemez!...', tip: 'error' });
      return;
    }


    if (parseInt(GonderiTipvalue) === 0) {
      setUyari({ open: true, aciklama: 'Kargo girilmeden kabul edilemez!...', tip: 'error' });
      return;
    }

    var DepoAdres = dataPaslasma.filter(d => d.ID === passEditParam);

    var DepoAdresId = DepoAdres[0].WarehouseAddress;

    const data = {
      GONDERIM_TIP: GonderiTipvalue,
      KARGO_NO: KargoNovalue,
      ID: passEditParam,
      USERID: user.UserId,
      DepoAdresId: DepoAdresId,
      EFATURA_NO: EFaturaNo
    };
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios.post('/SetPassGonderimBilgisi', data, config)
      .then(response => {
        if (response.data.ErrorCode === "0") {
          setUyari({ open: true, aciklama: 'İşlem başarılı', tip: 'success' });
        } else {
          setUyari({ open: true, aciklama: response.data.ErrorDescription, tip: 'error' });
        }
        GetOpenPassByService();
        setLoading(false);
        setPassEdit(false);
      }).catch(error => {
        setUyari({ open: true, aciklama: 'Bir hata oluştu!..' + error.message, tip: 'error' });
        setLoading(false);
      });
  };

  function SetGonderimBilgisi() {
    const isCountingPeriodActivated = sessionStorage.getItem("isCountingPeriod");
    // Bu kod sayım dönemi bitince açılacak
    if (parseInt(isCountingPeriodActivated) === 0 && (parseInt(GonderiTipvalue) === 1
      || parseInt(GonderiTipvalue) === 3
      || parseInt(GonderiTipvalue) === 4
      || parseInt(GonderiTipvalue) === 5)
    ) {
      setPassEdit(false);
      confirmAlert({
        message: "Aras Kargo dışında yapılan kargo gönderilerinde Arçelik tarafından anlaşma yapılmadığı için ödemeyi Arçelik karşılamayacaktır. Bu kargo firmasını kullanmak istediğinize emin misiniz?",
        buttons: [
          {
            label: 'Evet',
            onClick: () => SetGonderimBilgisiEvet()
          },
          {
            label: 'Hayır',
            onClick: () => {
              return;
            }
          }
        ]
      });
    } else {
      SetGonderimBilgisiEvet();
    }
  }

  const search = "";

  const setAdres = (param, index, MALZEME_STOK_NO) => {
    axios.get(`/GetAdresMalzemeKullanilabilirAdet/${user.ServiceShopId}/${param.Id}/${MALZEME_STOK_NO}`)
      .then(response => {
        let old_rows = [...dataPaslasma];
        old_rows[index].WarehouseAddress = param?.Id || 0;
        old_rows[index].WarehouseAddressText = param?.Description || 0;
        old_rows[index].Malzemeleri = param?.Materials || 0;
        old_rows[index].ADRES_ADET = response.data;
        setPaslasmaData(old_rows);
      })
      .catch(error => {
        console.log(error);
      });
  }


  const GetPrintPopUp = (event, ID, Name, Phone, Address, KargoOdemeDurum) => {
    setEtiket(ID);
    setName(Name);
    setPhone(Phone);
    setAddress(Address);
    setKargoOdemeDurum(KargoOdemeDurum);
    setPrint(true);

  }

  const SetPrintParam = (event) => {
    var content = document.getElementById("dvPrint");
    let pri;
    const iframe = document.createElement('iframe')
    iframe.setAttribute('title', Etiket)
    iframe.setAttribute('id', Etiket)
    iframe.setAttribute('style', 'height: 0px; width: 0px; position: absolute;')
    document.body.appendChild(iframe);
    pri = iframe.contentWindow;
    pri.document.open();
    pri.document.write(content.innerHTML);
    pri.document.close();
    pri.focus();
    pri.print();

  }


  function PassProcess(ISLEM_TIPI, ID) {
    confirmAlert({
      message: 'Daha önce onayladığınız paslaşmayı red ediyorsunuz. Devam etmek istediğinzden eminmisiniz?',
      buttons: [
        {
          label: 'Evet',
          onClick: () => PassProcessKabul(ISLEM_TIPI, ID)
        },
        {
          label: 'Hayır',
          onClick: () => {
            return;
          }
        }
      ]
    });
  }
  function PassProcessKabul(ISLEM_TIPI, ID) {
    setLoading(true);
    const data = {
      ISLEM_TIPI: ISLEM_TIPI,
      ID: ID,
      USERID: user.UserId
    };
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios.post('/SetPassProcess', data, config)
      .then(response => {
        if (response.data.ErrorCode === "0") {
          setUyari({ open: true, aciklama: 'İşlem başarılı', tip: 'success' });
        } else {
          setUyari({ open: true, aciklama: response.data.ErrorDescription, tip: 'error' });
        }
        GetOpenPassByService();
        setLoading(false);
      }).catch(error => {
        setUyari({ open: true, aciklama: 'Bir hata oluştu!..' + error.message, tip: 'error' });
        setLoading(false);
      });

  }

  return (
    <Page className={classes.root} title="oasis Yönetimi">
      <Container maxWidth="xl">
        <Card>
          <CardHeader title={' Paslaşma Çıkışı'}></CardHeader>
          <Backdrop className={classes.backdrop} open={Loading}>
            <CircularProgress color="inherit" />
          </Backdrop>
          <Divider />
          <Snackbar open={uyari.open} autoHideDuration={6000}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={uyariKapat}>
            <Alert onClose={uyariKapat} severity={uyari.tip}>
              {uyari.aciklama || ''}
            </Alert>
          </Snackbar>
        </Card>
        <TableContainer component={Paper} className={classes.tableContainer} style={{ height: containerHeight }}>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell align="left">ÇıkışYap</TableCell>
                <TableCell align="left">İptal</TableCell>
                <TableCell align="left">PaslaşmaNo</TableCell>
                <TableCell align="left">Servis</TableCell>
                <TableCell align="left">Adı</TableCell>
                <TableCell align="left">Telefon</TableCell>
                <TableCell align="left">AçıkAdres</TableCell>
                <TableCell align="left">Tarih</TableCell>
                <TableCell align="left">Durum</TableCell>
                <TableCell align="left">MalzemeKodu</TableCell>
                <TableCell align="left">Malzeme</TableCell>
                <TableCell align="left">Adet</TableCell>
                <TableCell align="left">GönderiTip</TableCell>
                <TableCell align="left">GönderiKodu</TableCell>
                <TableCell align="left">KargoÖdeme</TableCell>
                <TableCell align="left">Adres</TableCell>
                <TableCell align="left">AdresAdet</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {dataPaslasma.slice(pagination.page * pagination.rowsPerPage, (pagination.page + 1) * pagination.rowsPerPage).map((row, index) => (
                <TableRow key={index}>
                  <TableCell align="left" className={classes.tableCell}>
                    {
                      row.EDITABLE === 0 ? '' : <SendIcon
                        onClick={(event) => GetPassEditPopUp(event, row.ID)}
                        color="primary" />
                    }

                  </TableCell>
                  <TableCell align="left">
                    {
                      <DeleteForeverIcon
                        onClick={() => PassProcess(2, row.ID)}
                        color="error" />
                    }

                  </TableCell>
                  <TableCell align="left" >
                    {row.PASLASMA_NO}
                  </TableCell>
                  <TableCell align="left" >
                    {row.SERVIS}
                  </TableCell>
                  <TableCell align="left" >
                    {row.TALEP_EDEN}
                  </TableCell>
                  <TableCell align="left" >
                    {row.TELEFON}
                  </TableCell>
                  <TableCell align="left" >
                    {row.ACIK_ADRES}
                  </TableCell>
                  <TableCell align="left" >
                    {row.TARIH}
                  </TableCell>
                  <TableCell align="left" >
                    {row.DURUM}
                  </TableCell>
                  <TableCell align="left" >
                    {row.MALZEME_STOK_NO}
                  </TableCell>
                  <TableCell align="left" >
                    {row.MALZEME_ACIKLAMA}
                  </TableCell>
                  <TableCell align="left">
                    {row.ADET}
                  </TableCell>
                  <TableCell align="left">
                    {row.GONDERI_TIP}
                  </TableCell>
                  <TableCell align="left">
                    {row.GONDERI_KODU}
                  </TableCell>
                  <TableCell align="left">
                    {row.KARGO_ODEME_DURUM}
                  </TableCell>
                  <TableCell align="left">
                    <AddressSearch
                      setAdres={setAdres}
                      value={{
                        Id: row.WarehouseAddress || '0',
                        Description: row.WarehouseAddressText || 'Adres Seçiniz!...',
                        Materials: row.Malzemeleri | ''
                      } || ''}
                      searchParam={search}
                      MaterialCode={row.MALZEME_STOK_NO}
                      ServicePaperNr={row.FIS_NO}
                      index={index}
                      Adres={row.WarehouseAddress || 0}
                      RowSelected={1}
                      Tip={"Cikis1"}
                    />
                  </TableCell>
                  <TableCell align="left">
                    {row.ADRES_ADET}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={dataPaslasma.length}
          rowsPerPage={pagination.rowsPerPage}
          page={pagination.page}
          onChangePage={(e, v) => setPagination({ ...pagination, page: v })}
          onChangeRowsPerPage={e => setPagination({ page: 0, rowsPerPage: e.target.value })}
        />
      </Container>
      <Dialog
        open={passEdit}
        onClose={() => setPassEdit(false)}
        keepMounted
        maxWidth={'md'}
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">
          Gönderi Bilgileri
        </DialogTitle>
        <Divider />
        <DialogContent>

          <div className={classes.root}>

            <Grid container spacing={1}>
              <Grid item xs={12} sm={12}>
                <Typography component="h1"
                  gutterBottom
                  variant="h6">
                  Gönderi Tipi
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12}>
                <Select
                  fullWidth
                  value={GonderiTipvalue}
                  onChange={handleGonderiTipInputChange}>
                  <MenuItem value={0}>Seçiniz!...</MenuItem>
                  <MenuItem value={1}>Yurtiçi Kargo</MenuItem>
                  <MenuItem value={2}>Aras Kargo</MenuItem>
                  <MenuItem value={3}>PTT Kargo</MenuItem>
                  <MenuItem value={4}>Ay Kargo</MenuItem>
                  <MenuItem value={5}>Sürat Kargo</MenuItem>
                  <MenuItem value={6}>Elden Teslim</MenuItem>
                  <MenuItem value={7}>Bölge Aracı</MenuItem>
                </Select>
              </Grid>
              <Grid item xs={12} sm={12}>
                <br />
              </Grid>
              <Grid item xs={12} sm={12}>
                <Typography component="h1"
                  gutterBottom
                  variant="h6">
                  Kargo Takip No
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12}>
                <Input
                  fullWidth
                  InputProps={{
                    classes: {
                      input: classes.resize,
                    },
                  }}
                  value={KargoNovalue}
                  onChange={handleKargoNoInputChange}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <Typography component="h1"
                  gutterBottom
                  variant="h6">
                  EFaturaNo
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12}>
                <Input
                  fullWidth
                  InputProps={{
                    classes: {
                      input: classes.resize,
                    },
                  }}
                  value={EFaturaNo}
                  onChange={handleEFaturaNoInputChange}
                />
              </Grid>
            </Grid>
          </div>


        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => SetGonderimBilgisi()}
            className={classes.button}
            endIcon={<SendIcon>Close</SendIcon>}
          >
            Kabul Et
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={Print}
        onClose={() => setPrint(false)}
        maxWidth={'md'}
        keepMounted
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">
          Etiket Bas
        </DialogTitle>
        <Divider />
        <DialogContent>
          {Etiket !== '' ? <div id='dvPrint'><BarcodeImage Barcode={Etiket} Name={Name} Phone={Phone} Address={Address} KargoOdemeDurum={KargoOdemeDurum} /></div> : ''}
        </DialogContent>
        <DialogActions>

          <Button
            variant="contained"
            color="secondary"
            onClick={(event) => SetPrintParam(event)}
            className={classes.button}
            endIcon={<PrintIcon>Close</PrintIcon>}
          >
            Yazdır
          </Button>
        </DialogActions>
      </Dialog>
    </Page>
  );
}

export default PassOut;
